<!-- Existing dashboard -->
<div *ngIf="!isExternalUser">
  <!-- Existing dashboard content -->

<div class="dashboard-page">
  <div class="dashboard-topbar">
    <div class="dashboard-title-wrap">
      <h1 class="dashboard-title app-title">Dashboard</h1>
      <p class="dashboard-subtitle">Overview of verification activity and agent performance</p>
    </div>

    <div class="dashboard-controls">
      <!-- PPO / HMO -->
      <div class="control-group control-plan">
        <div class="control-label">&nbsp;</div>
        <div class="toggle-switch-planType plan-toggle">
          <div class="toggle-option"
               [class.active]="selectedPlanType === 'PPO'"
               (click)="setPlan('PPO')">PPO</div>
          <div class="toggle-option"
               [class.active]="selectedPlanType === 'HMO'"
               (click)="setPlan('HMO')">HMO</div>
        </div>
      </div>

      <!-- Timezone -->
      <div class="control-group">
        <label for="timezoneSelect" class="control-label">Timezone</label>
        <select id="timezoneSelect"
                class="form-control form-control-sm dashboard-input timezoneSelect"
                [(ngModel)]="selectedTimezone"
                (change)="onTimezoneChange()">
          <option disabled selected value="">-- Select Timezone --</option>
          <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
        </select>
      </div>

      <!-- Start Date -->
      <div class="control-group">
        <label for="startDate" class="control-label">Start Date</label>
        <input type="text"
               id="startDate"
               #startDateInput
               class="form-control form-control-sm dashboard-input"
               placeholder="Start Date"
               bsDatepicker
               [(ngModel)]="startDate"
               (ngModelChange)="changeDate()"
               [bsConfig]="{rangeInputFormat: 'MM-DD-YYYY', placement: 'bottom', containerClass: 'theme-green', adaptivePosition: false}"
               [maxDate]="todaysDate">
      </div>

      <!-- End Date -->
      <div class="control-group">
        <label for="endDate" class="control-label">End Date</label>
        <input type="text"
               id="endDate"
               #endDateInput
               class="form-control form-control-sm dashboard-input"
               placeholder="End Date"
               bsDatepicker
               [(ngModel)]="endDate"
               (ngModelChange)="changeDate()"
               [bsConfig]="{rangeInputFormat: 'MM-DD-YYYY', placement: 'bottom', containerClass: 'theme-red', adaptivePosition: false}"
               [maxDate]="todaysDate">
      </div>
    </div>
  </div>

  <!-- KPI CARDS -->
  <div class="dashboard-kpi-grid">
    <!-- Total -->
    <div class="kpi-card kpi-total">
      <div class="kpi-top">
        <span class="kpi-label">Total</span>
        <i class="fas fa-users"></i>
      </div>
      <div class="kpi-value">{{ totalCount }}</div>
    </div>

    <!-- Assigned -->
    <div class="kpi-card kpi-assigned"
         matTooltip="{{ getFormTypesTooltip(overallStatus?.ASSIGNED?.formTypes) }}"
         matTooltipPosition="below"
         matTooltipClass="form-types-tooltip">
      <div class="kpi-top">
        <span class="kpi-label">Assigned</span>
        <i class="fas fa-user-check"></i>
      </div>
      <div class="kpi-value">{{ totalAssigned }}</div>
    </div>

    <!-- Verified -->
    <div class="kpi-card kpi-verified"
         matTooltip="{{ getFormTypesTooltip(overallStatus?.VERIFIED?.formTypes) }}"
         matTooltipPosition="below"
         matTooltipClass="form-types-tooltip">
      <div class="kpi-top">
        <span class="kpi-label">Verified</span>
        <i class="fas fa-shield-alt"></i>
      </div>

      <div class="kpi-verified-row">
        <div class="kpi-value">{{ totalVerified }}</div>
        <div class="kpi-progress-wrap">
          <div class="progress kpi-progress">
            <div class="progress-bar"
                 role="progressbar"
                 [style.width.%]="verifiedPercentage"
                 [attr.aria-valuenow]="verifiedPercentage"
                 aria-valuemin="0"
                 aria-valuemax="100">
            </div>
          </div>
          <div class="kpi-progress-text">{{ verifiedPercentage.toFixed(1) }}%</div>
        </div>
      </div>
    </div>

    <!-- Not Verified -->
    <div class="kpi-card kpi-notverified"
         matTooltip="{{ getFormTypesTooltip(overallStatus?.NOT_VERIFIED?.formTypes) }}"
         matTooltipPosition="below"
         matTooltipClass="form-types-tooltip">
      <div class="kpi-top">
        <span class="kpi-label">Not Verified</span>
        <i class="fas fa-times-circle"></i>
      </div>
      <div class="kpi-value">{{ totalNotVerified }}</div>
    </div>

    <!-- Pending -->
    <div class="kpi-card kpi-pending"
         matTooltip="{{ getFormTypesTooltip(overallStatus?.PENDING?.formTypes) }}"
         matTooltipPosition="below"
         matTooltipClass="form-types-tooltip">
      <div class="kpi-top">
        <span class="kpi-label">In Progress</span>
        <i class="fa-regular fa-clock"></i>
      </div>
      <div class="kpi-value">{{ totalPending }}</div>
    </div>

    <!-- Backlog -->
    <!-- <div class="kpi-card kpi-backlog"
         matTooltip="{{ getFormTypesTooltip(overallStatus?.BACKLOG?.formTypes) }}"
         matTooltipPosition="below"
         matTooltipClass="form-types-tooltip">
      <div class="kpi-top">
        <span class="kpi-label">Backlog</span>
        <i class="fas fa-tasks"></i>
      </div>
      <div class="kpi-value">{{ totalBacklog }}</div>
    </div> -->
  </div>

  <!-- MAIN GRID -->
  <div class="dashboard-main-grid">
    <!-- TABLE PANEL -->
    <div class="dashboard-panel panel-table">
    <div class="panel-header">

      <h4 class="panel-title">
        {{ showAgentsTable ? "Agent's Report" : "Project's Report" }}
      </h4>

      <div
        style="
          display:flex;
          align-items:center;
          gap:8px;
        ">

        <!-- SEARCH SECTION - ONLY FOR AGENTS -->
        <div
          *ngIf="showAgentsTable"
          style="
            display:flex;
            align-items:center;
            gap:8px;
          ">

          <!-- SEARCH ICON -->
          <button
            type="button"
            class="extraction-filter-btn"
            [class.active]="showAgentSearch || agentSearchTerm"
            title="Search agent"
            (click)="showAgentSearch = true">

            <i class="fas fa-search"></i>

          </button>

          <!-- EXPANDING SEARCH BAR -->
          <div
            style="
              display:flex;
              align-items:center;
              overflow:hidden;
              height:40px;
              border:1px solid #dde6f1;
              border-radius:12px;
              background:#ffffff;
              box-shadow:0 6px 18px rgba(31,41,55,0.08);
              transition:all 0.22s ease;
            "
            [style.width]="showAgentSearch ? '220px' : '0px'"
            [style.opacity]="showAgentSearch ? '1' : '0'"
            [style.marginLeft]="showAgentSearch ? '0px' : '-8px'"
            [style.borderWidth]="showAgentSearch ? '1px' : '0px'">

            <!-- INNER SEARCH ICON -->
            <span
              style="
                width:34px;
                min-width:34px;
                display:flex;
                align-items:center;
                justify-content:center;
                color:#1686f5;
              ">

              <i class="fas fa-search" style="font-size:11px;"></i>

            </span>

            <!-- INPUT -->
            <input
              type="text"
              [(ngModel)]="agentSearchTerm"
              placeholder="Search agent..."
              style="
                flex:1;
                min-width:0;
                height:100%;
                border:0;
                outline:none;
                background:transparent;
                font-size:12px;
                color:#334155;
                padding:0 4px;
              ">

            <!-- CLOSE -->
            <button
              type="button"
              title="Close search"
              (click)="closeAgentSearch()"
              style="
                width:32px;
                min-width:32px;
                height:100%;
                border:0;
                background:transparent;
                color:#8592a3;
                display:flex;
                align-items:center;
                justify-content:center;
                cursor:pointer;
              ">

              <i class="fas fa-times" style="font-size:10px;"></i>

            </button>

          </div>

        </div>

        <!-- AGENTS / PROJECTS - ALWAYS VISIBLE -->
        <div class="toggle-switch">

          <div
            class="toggle-option"
            [class.active]="showAgentsTable"
            (click)="toggleTable(true)">
            Agents
          </div>

          <div
            class="toggle-option"
            [class.active]="!showAgentsTable"
            (click)="toggleTable(false)">
            Projects
          </div>

        </div>

      </div>

    </div>

      <div class="panel-body table-panel-body">
        <div class="table-responsive table-r">
          <div [@fadeInOut]>
            <!-- Agent Table -->
            <table *ngIf="showAgentsTable" class="table dashboard-table align-middle mb-0">
              <thead>
              <tr>
                <th>Sr.No</th>
                <th>Name</th>
                <th>User Name</th>
                <th>Assigned</th>
                <th>Verified</th>
                <th>Not Verified</th>
                <th>In Progress</th>
                <!-- <th>Backlog</th> -->
                <th>Short Form Avg</th>
                <th>Full Form Avg</th>
              </tr>
              </thead>

              <tbody *ngFor="let table of filteredAgentsTableData; let i = index">
              <tr>
                <td>{{ i + 1 }}</td>
                <td class="fw-semibold">{{ table.firstName + ' ' + table.lastName || '-' }}</td>
                <td>{{ table.userName || '-' }}</td>

                <td>
                  <span class="badge badge-pill badge-soft badge-assigned">
                    {{ table.totalCount || '-' }}
                  </span>
                </td>

                <td>
                  <span class="badge badge-pill badge-soft badge-verified"
                        matTooltip="{{ getFormTypesTooltip(table?.verificationStatus?.VERIFIED?.formTypes) }}"
                        matTooltipPosition="below"
                        matTooltipClass="form-types-tooltip">
                    {{ table?.verificationStatus?.VERIFIED?.count || 0 }}
                  </span>
                </td>

                <td>
                  <span class="badge badge-pill badge-soft badge-notverified"
                        matTooltip="{{ getFormTypesTooltip(table?.verificationStatus?.NOT_VERIFIED?.formTypes) }}"
                        matTooltipPosition="below"
                        matTooltipClass="form-types-tooltip">
                    {{ table?.verificationStatus?.NOT_VERIFIED?.count || 0 }}
                  </span>
                </td>

                <td>
                  <span class="badge badge-pill badge-soft badge-pending"
                        matTooltip="{{ getFormTypesTooltip(table?.verificationStatus?.PENDING?.formTypes) }}"
                        matTooltipPosition="below"
                        matTooltipClass="form-types-tooltip">
                    {{ table?.verificationStatus?.PENDING?.count || 0 }}
                  </span>
                </td>

                <!-- <td>
                  <span class="badge badge-pill badge-soft badge-backlog"
                        matTooltip="{{ getFormTypesTooltip(table?.verificationStatus?.BACKLOG?.formTypes) }}"
                        matTooltipPosition="below"
                        matTooltipClass="form-types-tooltip">
                    {{ table?.verificationStatus?.BACKLOG?.count || 0 }}
                  </span>
                </td> -->

                <td>
                  <span class="badge badge-pill badge-soft badge-time">
                    {{ getAgentAvgTime(table, 'SHORT FORM') }}
                  </span>
                </td>

                <td>
                  <span class="badge badge-pill badge-soft badge-time">
                    {{ getAgentAvgTime(table, 'FULL FORM') }}
                  </span>
                </td>
              </tr>
              </tbody>

            <tbody *ngIf="filteredAgentsTableData.length === 0">

              <tr>

                <td
                  colspan="10"
                  class="text-center fw-semibold empty-row">

                  <ng-container *ngIf="agentSearchTerm">
                    No agent found matching "{{ agentSearchTerm }}"
                  </ng-container>

                  <ng-container *ngIf="!agentSearchTerm">
                    No record found!
                  </ng-container>

                </td>

              </tr>

            </tbody>
            </table>

            <!-- Project Table -->
            <table *ngIf="!showAgentsTable" class="table dashboard-table align-middle mb-0">
              <thead>
              <tr>
                <th>Sr.No</th>
                <th>Client</th>
                <th>UnAssigned</th>
                <th>Assigned</th>
                <th>Verified</th>
                <th>Not Verified</th>
                <th>In Progress</th>
                <!-- <th>Backlog</th> -->
                <th>Total count</th>
              </tr>
              </thead>

              <tbody *ngFor="let project of projectsTableData; let projIndex = index">
              <tr *ngFor="let agent of project.agents; let agentIndex = index">
                <td>{{ projIndex + 1 }}</td>
                <td class="fw-semibold">{{ agent.firstName + ' ' + agent.lastName || '-' }}</td>
                <td><span class="badge badge-pill badge-soft badge-unassigned">{{ agent?.verificationStatusCount?.UNASSIGNED || '-' }}</span></td>
                <td><span class="badge badge-pill badge-soft badge-assigned">{{ agent?.verificationStatusCount?.ASSIGNED || '-' }}</span></td>
                <td><span class="badge badge-pill badge-soft badge-verified">{{ agent?.verificationStatusCount?.VERIFIED || '-' }}</span></td>
                <td><span class="badge badge-pill badge-soft badge-notverified">{{ agent?.verificationStatusCount?.NOT_VERIFIED || '-' }}</span></td>
                <td><span class="badge badge-pill badge-soft badge-pending">{{ agent?.verificationStatusCount?.PENDING || '-' }}</span></td>
                <!-- <td><span class="badge badge-pill badge-soft badge-backlog">{{ agent?.verificationStatusCount?.BACKLOG || '-' }}</span></td> -->
                <td>{{ agent.totalCount || '-' }}</td>
              </tr>
              </tbody>

              <tbody *ngIf="!projectsTableData || projectsTableData.length === 0">
              <tr>
                <td colspan="9" class="text-center fw-semibold empty-row">No record found!</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- EXTRACTION METRICS PANEL -->
    <div class="dashboard-panel panel-chart">

      <div class="panel-header extraction-metrics-header">
        <h4 class="panel-title">Extraction Metrics</h4>

        <div class="metrics-header-actions">

          <!-- Single client / All clients -->
          <div class="toggle-switch extraction-scope-toggle">
            <div
              class="toggle-option"
              [class.active]="extractionClientScope === 'SINGLE'"
              (click)="setExtractionClientScope('SINGLE')">
              Current Client
            </div>

            <div
              class="toggle-option"
              [class.active]="extractionClientScope === 'ALL'"
              (click)="setExtractionClientScope('ALL')">
              All Clients
            </div>
          </div>

          <!-- Extraction filter -->
          <div class="extraction-filter-wrap">

            <button
              type="button"
              class="extraction-filter-btn"
              [class.active]="showExtractionFilters || hasActiveExtractionFilters"
              (click)="toggleExtractionFilters($event)">

              <i class="fas fa-filter"></i>

              <span
                class="filter-active-dot"
                *ngIf="hasActiveExtractionFilters">
              </span>
            </button>

            <div
              class="extraction-filter-popup"
              *ngIf="showExtractionFilters"
              (click)="$event.stopPropagation()">

              <div class="filter-popup-header">
                <span>Filters</span>

                <button
                  type="button"
                  class="filter-close-btn"
                  (click)="showExtractionFilters = false">
                  <i class="fas fa-times"></i>
                </button>
              </div>

              <div class="filter-popup-group">
                <label>Status</label>

                <select
                  class="form-control form-control-sm"
                  [(ngModel)]="selectedExtractionStatus">
                  <option
                    *ngFor="let status of extractionStatuses"
                    [ngValue]="status">
                    {{ status }}
                  </option>
                </select>
              </div>

              <div class="filter-popup-group">
                <label>Insurance</label>

                <mat-select
                  class="form-control form-control-sm extraction-filter-select"
                  panelClass="extraction-insurance-panel"
                  multiple
                  [(ngModel)]="selectedExtractionSources"
                  (openedChange)="onInsuranceDropdownChange($event)">

                  <div class="extraction-insurance-bulk-actions"
                       (click)="$event.stopPropagation()"
                       (keydown)="$event.stopPropagation()">
                    <button
                      type="button"
                      (click)="selectAllExtractionSources()"
                      [disabled]="selectedExtractionSources.length === extractionSources.length">
                      Select All
                    </button>
                    <button
                      type="button"
                      (click)="clearAllExtractionSources()"
                      [disabled]="selectedExtractionSources.length === 0">
                      Clear All
                    </button>
                  </div>

                  <mat-option
                    *ngFor="let source of extractionSources"
                    [value]="source">
                    {{
                      source === 'DENTAL_TOOLKIT'
                        ? 'DENTAL TOOLKIT'
                        : source === 'DELTA_DENTAL_INS'
                          ? 'DELTA DENTAL INS'
                        : source === 'LIBERTY_DENTAL'
                        ? 'LIBERTY DENTAL'
                        : source === 'DENTICON'
                        ? 'Denticon Pasting'
                        : source === 'DELTA_DENTAL_INS_SHORTFORM'
                        ? 'DELTA DENTAL INS SHORTFORM'
                        : source === 'dentalxchange'
                        ? 'Dental Xchange'
                        : source
                    }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="filter-popup-actions">
                <button
                  type="button"
                  class="btn btn-sm btn-light"
                  (click)="resetExtractionFilters()">
                  Reset
                </button>

                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  (click)="applyExtractionFilters()">
                  Apply
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>

      <div class="panel-body extraction-insights-body">

        <div
          class="chart-loading"
          *ngIf="isExtractionMetricsLoading">
          <i class="fas fa-spinner fa-spin"></i>
          Loading extraction metrics...
        </div>

        <ng-container *ngIf="!isExtractionMetricsLoading">
          <div class="extraction-outcome-grid">

            <div class="extraction-outcome-card extraction-outcome-total">
              <div class="outcome-card-icon">
                <i class="fas fa-layer-group"></i>
              </div>

              <div class="outcome-card-content">
                <span class="summary-label">Total Extractor Runs</span>
                <strong>{{ extractionTotalCount }}</strong>
              </div>
            </div>

            <button
              type="button"
              class="extraction-outcome-card extraction-outcome-success"
              [class.active]="extractionDrilldownStatus === 'SUCCESS'"
              [disabled]="extractionSuccessCount === 0"
              (click)="showExtractionPatientPreview('SUCCESS')">

              <div class="outcome-card-icon">
                <i class="fas fa-check"></i>
              </div>

              <div class="outcome-card-content">
                <span class="summary-label">Successful</span>
                <strong>{{ extractionSuccessCount }}</strong>
              </div>
            </button>

            <button
              type="button"
              class="extraction-outcome-card extraction-outcome-failed"
              [class.active]="extractionDrilldownStatus === 'FAILED'"
              [disabled]="extractionFailedCount === 0"
              (click)="showExtractionPatientPreview('FAILED')">

              <div class="outcome-card-icon">
                <i class="fas fa-user-slash"></i>
              </div>

              <div class="outcome-card-content">
                <span class="summary-label">Patient Not Found</span>
                <strong>{{ extractionFailedCount }}</strong>
              </div>
            </button>
          </div>

          <div class="extraction-doughnut-section">
            <div class="extraction-doughnut-copy">
              <span class="doughnut-title">Extractor Outcome Mix</span>
              <span class="doughnut-subtitle">Total, successful and patient not found distribution</span>
            </div>

            <div class="extraction-doughnut-layout extraction-doughnut-three">

              <div class="extraction-doughnut-metric">
                <div
                  class="extraction-doughnut"
                  [style.background]="extractionDoughnutBackground"
                  role="img"
                  [attr.aria-label]="
                    'Total extractor runs ' + extractionTotalCount
                  ">
                  <div class="extraction-doughnut-center">
                    <strong>{{ extractionTotalCount }}</strong>
                    <span>Total</span>
                  </div>
                </div>

                <div class="extraction-doughnut-label">
                  <span>Total Runs</span>
                  <strong>{{ extractionTotalCount }}</strong>
                </div>
              </div>

              <div class="extraction-doughnut-metric">
                <div
                  class="extraction-doughnut extraction-doughnut-success extraction-doughnut-svg-wrap"
                  role="img"
                  [attr.aria-label]="
                    'Successful ' +
                    extractionSuccessCount +
                    ', ' +
                    (extractionSuccessRate | number:'1.0-1') +
                    ' percent'
                  ">

                  <svg
                    class="extraction-doughnut-svg"
                    viewBox="0 0 80 80"
                    aria-hidden="true">

                    <circle
                      class="doughnut-ring-track doughnut-ring-track-success"
                      cx="40"
                      cy="40"
                      r="32"
                      pathLength="100">
                    </circle>

                    <circle
                      class="doughnut-ring-progress doughnut-ring-progress-success"
                      cx="40"
                      cy="40"
                      r="32"
                      pathLength="100"
                      [attr.stroke-dasharray]="
                        extractionSuccessRate +
                        ' ' +
                        (100 - extractionSuccessRate)
                      ">
                    </circle>
                  </svg>

                  <div class="extraction-doughnut-center">
                    <strong>{{ extractionSuccessCount }}</strong>
                    <span>Success</span>
                  </div>
                </div>

                <div class="extraction-doughnut-label success">
                  <span>Successful</span>
                  <strong>{{ extractionSuccessRate | number:'1.0-1' }}%</strong>
                </div>
              </div>

              <div class="extraction-doughnut-metric">
                <div
                  class="extraction-doughnut extraction-doughnut-failed extraction-doughnut-svg-wrap"
                  role="img"
                  [attr.aria-label]="
                    'Patient Not Found ' +
                    extractionFailedCount +
                    ', ' +
                    (extractionFailedRate | number:'1.0-1') +
                    ' percent'
                  ">

                  <svg
                    class="extraction-doughnut-svg"
                    viewBox="0 0 80 80"
                    aria-hidden="true">

                    <circle
                      class="doughnut-ring-track doughnut-ring-track-failed"
                      cx="40"
                      cy="40"
                      r="32"
                      pathLength="100">
                    </circle>

                    <circle
                      class="doughnut-ring-progress doughnut-ring-progress-failed"
                      cx="40"
                      cy="40"
                      r="32"
                      pathLength="100"
                      [attr.stroke-dasharray]="
                        extractionFailedRate +
                        ' ' +
                        (100 - extractionFailedRate)
                      ">
                    </circle>
                  </svg>

                  <div class="extraction-doughnut-center">
                    <strong>{{ extractionFailedCount }}</strong>
                    <span>Not Found</span>
                  </div>
                </div>

                <div class="extraction-doughnut-label failed">
                  <span>Patient Not Found</span>
                  <strong>{{ extractionFailedRate | number:'1.0-1' }}%</strong>
                </div>
              </div>

            </div>
          </div>

          <div
            class="extraction-empty-state extraction-metrics-empty"
            *ngIf="extractionTotalCount === 0">
            <i class="fas fa-inbox"></i>
            <span>No extraction records found for the selected filters.</span>
          </div>
        </ng-container>
      </div>


    </div>
  </div>


  <div
    class="dashboard-panel mt-4 client-performance-panel"
    *ngIf="this.authService.hasAnyRole(['client-edit'])">

    <div class="panel-header client-performance-header">
      <div>
        <h4 class="panel-title">Client Agent Status</h4>
        <span class="client-performance-subtitle">
          Live agent availability and operational verification workload by client
        </span>
      </div>
    </div>

    <div class="panel-body table-panel-body">
    <div class="table-responsive table-c">
      <table class="table dashboard-table align-middle mb-0">
        <thead>
          <tr>
            <th>Client</th>
            <th>Agent</th>
            <th>Assigned</th>
            <th>Verified</th>
            <th>Not Verified</th>
            <th>In Progress</th>
            <!-- <th>Backlog</th> -->
            <th>Short Form Avg</th>
            <th>Full Form Avg</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let client of adminClients">

            <!-- Client has agents -->
            <ng-container *ngIf="client.users && client.users.length > 0">
              <tr *ngFor="let user of client.users; let i = index">

                <td
                  *ngIf="i === 0"
                  [attr.rowspan]="client.users.length"
                  class="fw-semibold align-middle text-center">

                  {{ client.clientName }}
                </td>

                <td class="fw-semibold text-center">
                  {{ getAgentName(user) }}
                </td>

                <td class="text-center">
                  <span class="badge badge-pill badge-soft badge-assigned">
                    {{ user.totalCount || 0 }}
                  </span>
                </td>

                <td class="text-center">
                  <span
                    class="badge badge-pill badge-soft badge-verified"
                    matTooltip="{{ getFormTypesTooltip(user?.verificationStatus?.VERIFIED?.formTypes) }}"
                    matTooltipPosition="below"
                    matTooltipClass="form-types-tooltip">

                    {{ getVerificationCount(user, 'VERIFIED') }}
                  </span>
                </td>

                <td class="text-center">
                  <span
                    class="badge badge-pill badge-soft badge-notverified"
                    matTooltip="{{ getFormTypesTooltip(user?.verificationStatus?.NOT_VERIFIED?.formTypes) }}"
                    matTooltipPosition="below"
                    matTooltipClass="form-types-tooltip">

                    {{ getVerificationCount(user, 'NOT_VERIFIED') }}
                  </span>
                </td>

                <td class="text-center">
                  <span
                    class="badge badge-pill badge-soft badge-pending"
                    matTooltip="{{ getFormTypesTooltip(user?.verificationStatus?.PENDING?.formTypes) }}"
                    matTooltipPosition="below"
                    matTooltipClass="form-types-tooltip">

                    {{ getVerificationCount(user, 'PENDING') }}
                  </span>
                </td>

                <!-- <td class="text-center">
                  <span
                    class="badge badge-pill badge-soft badge-backlog"
                    matTooltip="{{ getFormTypesTooltip(user?.verificationStatus?.BACKLOG?.formTypes) }}"
                    matTooltipPosition="below"
                    matTooltipClass="form-types-tooltip">

                    {{ getVerificationCount(user, 'BACKLOG') }}
                  </span>
                </td> -->

                <td class="text-center">
                  <span class="badge badge-pill badge-soft badge-time">
                    {{ getAverageTime(user, 'SHORT FORM') }}
                  </span>
                </td>

                <td class="text-center">
                  <span class="badge badge-pill badge-soft badge-time">
                    {{ getAverageTime(user, 'FULL FORM') }}
                  </span>
                </td>

                <td class="text-center">
                  <span
                    class="badge badge-pill"
                    [ngClass]="user.online ? 'badge-online' : 'badge-offline'">

                    <span
                      class="status-dot"
                      [ngClass]="user.online ? 'dot-online' : 'dot-offline'">
                    </span>

                    {{ user.online ? 'Online' : 'Offline' }}
                  </span>
                </td>

              </tr>
            </ng-container>

            <!-- Client has no agents -->
            <tr *ngIf="!client.users || client.users.length === 0">
            <td class="fw-semibold text-center">
              {{ client.clientName }}
            </td>

            <td class="text-center fw-semibold empty-row">
              No agents assigned
            </td>

            <td class="text-center">
              <span class="badge badge-pill badge-soft badge-assigned">0</span>
            </td>

            <td class="text-center">
              <span class="badge badge-pill badge-soft badge-verified">0</span>
            </td>

            <td class="text-center">
              <span class="badge badge-pill badge-soft badge-notverified">0</span>
            </td>

            <td class="text-center">
              <span class="badge badge-pill badge-soft badge-pending">0</span>
            </td>

            <td class="text-center">
              <span class="badge badge-pill badge-soft badge-backlog">0</span>
            </td>

            <td class="text-center">
              <span class="badge badge-pill badge-soft badge-time">0 sec</span>
            </td>

            <td class="text-center">
              <span class="badge badge-pill badge-soft badge-time">0 sec</span>
            </td>

            <td class="text-center">
              <span class="badge badge-pill badge-unavailable">
                <span class="status-dot dot-unavailable"></span>
                Unavailable
              </span>
            </td>
          </tr>

          </ng-container>
        </tbody>

        <!-- No clients found -->
        <tbody *ngIf="!adminClients || adminClients.length === 0">
          <tr>
            <td colspan="10" class="text-center fw-semibold empty-row">
              No client data found!
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  </div>

  <!-- <div class="verification-time-grid mt-4">
  <div class="dashboard-panel">
    <div class="panel-header">
      <h4 class="panel-title">Verification Time Analytics</h4>
    </div>

    <div class="verification-chart-body">
      <canvas id="verificationTimeChart"></canvas>
    </div>
  </div>

  <div class="dashboard-panel">
    <div class="panel-header">
      <h4 class="panel-title">Top Agents by Average Verification Time</h4>
    </div>

    <div class="panel-body table-panel-body">
      <table class="table dashboard-table align-middle mb-0">
        <thead>
        <tr>
          <th>Rank</th>
          <th>Agent</th>
          <th>Short Form</th>
          <th>Full Form</th>
          <th>Avg Time</th>
          <th>Verified</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let agent of topAgentsByAvgTime; let i = index">
          <td>{{ i + 1 }}</td>
          <td class="fw-semibold">{{ agent.name }}</td>
          <td>{{ agent.shortFormTime }}</td>
          <td>{{ agent.fullFormTime }}</td>
          <td>{{ agent.avgFormatted }}</td>
          <td>
            <span class="badge badge-pill badge-soft badge-verified">
              {{ agent.verifiedCount }}
            </span>
          </td>
        </tr>
        </tbody>

        <tbody *ngIf="!topAgentsByAvgTime || topAgentsByAvgTime.length === 0">
        <tr>
          <td colspan="6" class="text-center fw-semibold empty-row">
            No verification time data found!
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div> -->

  
</div>

  <!-- Render outside dashboard-page so fixed positioning is viewport-based and never clipped by the metric card. -->
  <!-- Patient drilldown is shown as a modal instead of expanding the dashboard. -->
      <div
        class="extraction-patient-modal-backdrop"
        *ngIf="extractionDrilldownStatus && extractionDrilldownTotal > 0"
        (click)="closeExtractionPatientPreview()">

        <div
          class="extraction-patient-modal"
          role="dialog"
          aria-modal="true"
          [attr.aria-label]="
            extractionDrilldownStatus === 'SUCCESS'
              ? 'Successful Patients'
              : 'Patient Not Found'
          "
          (click)="$event.stopPropagation()">

          <div class="patient-preview-header">
            <div>
              <h5>
                {{
                  extractionDrilldownStatus === 'SUCCESS'
                    ? 'Successful Patients'
                    : 'Patient Not Found'
                }}
              </h5>

              <span *ngIf="extractionDrilldownLoading">
                Loading {{ extractionDrilldownTotal }} matching records...
              </span>
              <span *ngIf="!extractionDrilldownLoading">
                Showing {{ extractionPatients.length }} of
                {{ extractionDrilldownTotal }} matching records
              </span>
            </div>

            <button
              type="button"
              class="patient-preview-close"
              title="Close patient list"
              (click)="closeExtractionPatientPreview()">
              <i class="fas fa-times"></i>
            </button>
          </div>

          <div
            class="patient-preview-state"
            *ngIf="extractionDrilldownLoading">
            <i class="fas fa-spinner fa-spin"></i>
            Loading patient details...
          </div>

          <div
            class="patient-preview-state patient-preview-error"
            *ngIf="!extractionDrilldownLoading && extractionDrilldownError">
            <i class="fas fa-exclamation-circle"></i>
            Unable to load patient details.
          </div>

          <div
            class="patient-preview-state"
            *ngIf="
              !extractionDrilldownLoading &&
              !extractionDrilldownError &&
              extractionPatients.length === 0
            ">
            No patients found for this outcome.
          </div>

          <div
            class="table-responsive patient-preview-table-wrap"
            *ngIf="
              !extractionDrilldownLoading &&
              !extractionDrilldownError &&
              extractionPatients.length > 0
            ">

            <table class="table dashboard-table extraction-patient-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Patient</th>
                  <th>DOB</th>
                  <th>Member ID</th>
                  <th>Client</th>
                  <th>Office</th>
                  <th>Insurance</th>
                  <th>Extracted On</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let patient of extractionPatients">
                  <td class="fw-semibold">{{ getExtractionPatientName(patient) }}</td>
                  <td>{{ patient.dateOfBirth || '-' }}</td>
                  <td>{{ patient.memberId || '-' }}</td>
                  <td>{{ patient.clientId || '-' }}</td>
                  <td>{{ patient.officeId || '-' }}</td>
                  <td>{{ getExtractionSourceLabel(patient.source) }}</td>
                  <td>{{ patient.createdAt || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
</div>

<!-- Provider dashboard -->
<div *ngIf="isExternalUser">
  <div class="dashboard-page">
    <div class="dashboard-topbar">
      <div class="dashboard-title-wrap">
        <h1 class="dashboard-title app-title">Dashboard</h1>
        <p class="dashboard-subtitle">Your patient registration requests and verification status</p>
      </div>

      <div class="dashboard-controls">
        <!-- <div class="control-group control-plan">
          <div class="control-label">&nbsp;</div>
          <div class="toggle-switch-planType plan-toggle">
            <div class="toggle-option"
                 [class.active]="selectedPlanType === 'PPO'"
                 (click)="setPlan('PPO')">PPO</div>
            <div class="toggle-option"
                 [class.active]="selectedPlanType === 'HMO'"
                 (click)="setPlan('HMO')">HMO</div>
          </div>
        </div> -->

        <div class="control-group">
          <label for="providerTimezoneSelect" class="control-label">Timezone</label>
          <select id="providerTimezoneSelect"
                  class="form-control form-control-sm dashboard-input timezoneSelect"
                  [(ngModel)]="selectedTimezone"
                  (change)="onTimezoneChange()">
            <option disabled value="">-- Select Timezone --</option>
            <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
          </select>
        </div>

        <div class="control-group">
          <label for="providerStartDate" class="control-label">Start Date</label>
          <input id="providerStartDate"
                 type="text"
                 class="form-control form-control-sm dashboard-input"
                 placeholder="Start Date"
                 bsDatepicker
                 [(ngModel)]="startDate"
                 (ngModelChange)="changeDate()"
                 [bsConfig]="{rangeInputFormat: 'MM-DD-YYYY', placement: 'bottom', containerClass: 'theme-green', adaptivePosition: false}"
                 [maxDate]="todaysDate">
        </div>

        <div class="control-group">
          <label for="providerEndDate" class="control-label">End Date</label>
          <input id="providerEndDate"
                 type="text"
                 class="form-control form-control-sm dashboard-input"
                 placeholder="End Date"
                 bsDatepicker
                 [(ngModel)]="endDate"
                 (ngModelChange)="changeDate()"
                 [bsConfig]="{rangeInputFormat: 'MM-DD-YYYY', placement: 'bottom', containerClass: 'theme-red', adaptivePosition: false}"
                 [maxDate]="todaysDate">
        </div>
      </div>
    </div>


    <div class="dashboard-kpi-grid provider-kpi-grid">
      <div class="kpi-card kpi-total">
        <div class="kpi-top"><span class="kpi-label">Total Requests</span><i class="fas fa-file-medical"></i></div>
        <div class="kpi-value">{{ providerSummary.totalRequests }}</div>
      </div>
      <div class="kpi-card kpi-assigned">
        <div class="kpi-top"><span class="kpi-label">Assigned</span><i class="fas fa-user-check"></i></div>
        <div class="kpi-value">{{ providerSummary.assigned }}</div>
      </div>
      <div class="kpi-card kpi-verified">
        <div class="kpi-top"><span class="kpi-label">Verified</span><i class="fas fa-shield-alt"></i></div>
        <div class="kpi-value">{{ providerSummary.verified }}</div>
      </div>
      <div class="kpi-card kpi-notverified">
        <div class="kpi-top"><span class="kpi-label">Not Verified</span><i class="fas fa-times-circle"></i></div>
        <div class="kpi-value">{{ providerSummary.notVerified }}</div>
      </div>
      <div class="kpi-card kpi-pending">
        <div class="kpi-top"><span class="kpi-label">In Progress</span><i class="fas fa-spinner"></i></div>
        <div class="kpi-value">{{ providerSummary.inProgress }}</div>
      </div>
    </div>

     <div class="provider-content-grid">

    <div *ngIf="!isExternalAdminOrSupervisor" class="dashboard-panel provider-table-panel">
      <div class="panel-header">
          <h4 class="panel-title">Patients Created by You</h4>
          <div *ngIf="authService.isExternalUser()"
               class="toggle-switch provider-register-toggle">
            <a class="toggle-option active provider-register-btn"
               [routerLink]="['/patient/register']">
              <i class="fas fa-user-plus"></i>
              <span>Register Patient</span>
            </a>
          </div>
        </div>
      <div class="panel-body provider-table-scrolls">
        <!-- <div class="table-responsive"> -->
        <table class="table dashboard-table align-middle mb-0" matSort>
          <thead>
          <tr>
            <th scope="col">Sr.No</th>
            <th>Name</th>
            <th>DOB</th>
            <th>PatientId</th>
            <th>Form Type</th>
            <th>Ins-Type</th>
            <th>Career Name</th>
            <!-- <th mat-sort-header="careerName">Payer ID</th> -->
            <!-- <th mat-sort-header="insuranceId">Ins-Id</th> -->
            <th>Member Id</th>
            <th>Sub-DOB</th>
            <!-- <th mat-sort-header="insurancePhone">Ins-phone</th> -->
            <th>APP-DATE</th>
            <th>APP-TIME</th>
            <!-- <th mat-sort-header="providerName">Provider Name</th> -->
            <!-- <th mat-sort-header="office">Office</th> -->
            <!-- <th mat-sort-header="groupNo">Grp-No</th> -->
            <!-- <th mat-sort-header="formFillTime">Timing</th> -->
            <th>Action</th>
          </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let table of providerPatients;
                let i = index;
                trackBy: trackByTableId
              "
              [ngClass]="{
                'urgent-row': table.urgency === 'URGENT'
              }">

              <th scope="row" class="text-center">
                {{
                  providerPagination.page *
                  providerPagination.size +
                  i +
                  1
                }}
              </th>

              <td class="text-center">
                <a
                  *ngIf="authService.isExternalUser()"
                  [routerLink]="['/patient/details', table.id]">
                {{
                  (
                    (table.firstName || '') +
                    ' ' +
                    (table.lastName || '')
                  ).trim() || '-'
                }}
                </a>
              </td>

              <td>{{ table.dob || '-' }}</td>
              <td>{{ table.patientId || '-' }}</td>
              <td>{{ table.formType || '-' }}</td>
              <td>{{ table.insuranceType || '-' }}</td>
              <!-- <td>{{ table.payerName || '-' }}</td> -->
              <td>{{ table.careerName || '-' }}</td>
              <!-- <td>{{ table.insuranceId || '-' }}</td> -->
              <td>{{ table.memberId || '-' }}</td>
              <td>{{ table.subscriberDob || '-' }}</td>
              <!-- <td>{{ table.insurancePhone || '-' }}</td> -->
              <td>{{ table.apptDate || '-' }}</td>
              <td>{{ table.apptTime || '-' }}</td>
              <!-- <td>{{ table.providerName || '-' }}</td> -->
              <!-- <td>{{ table.officeName || '-' }}</td> -->
              <!-- <td>{{ table.groupNo || '-' }}</td> -->
              <!-- <td>{{ table.formFillTime || '-' }}</td> -->

              <td>
                <a
                  *ngIf="authService.isExternalUser()"
                  class="provider-edit-link"
                  title="Edit"
                  [routerLink]="['/patient/details', table.id]">
                  <i class="fa-sm fa-solid fa-user-pen"></i>
                </a>
              </td>
            </tr>

            <tr
              *ngIf="
                !providerTableLoading &&
                (!providerPatients || providerPatients.length === 0)
              ">
              <td
                colspan="19"
                class="text-center font-weight-bold empty-row">
                No requests found.
              </td>
            </tr>
          </tbody>
        </table>
        <!-- </div> -->
      </div>
      <div *ngIf="providerPatients?.length !== 0" class="d-flex justify-content-end mt-3">
        <mat-paginator
          [length]="providerTotalRecords"
          [pageIndex]="providerPagination.page"
          [pageSize]="providerPagination.size"
          [pageSizeOptions]="providerPageSizeOptions"
          [showFirstLastButtons]="true"
          (page)="onProviderPageChange($event)">
        </mat-paginator>
      </div>
    </div>

    <div
      *ngIf="isExternalAdminOrSupervisor"
      class="dashboard-panel provider-table-panel">

      <div class="panel-header">

        <div>
          <h4 class="panel-title">
            Office's Report
          </h4>

          <span class="provider-table-subtitle">
            Provider verification activity by office
          </span>
        </div>

      </div>


      <div class="panel-body table-panel-body">

        <div class="table-responsive">

          <table
            class="table dashboard-table provider-office-table align-middle mb-0">

            <thead>
              <tr>
                <th>Office</th>
                <th>Provider</th>
                <th>Total</th>
                <th>Verified</th>
                <th>In Progress</th>
                <th>Not Verified</th>
                <th>Status</th>
              </tr>
            </thead>


            <tbody>

              <ng-container
                *ngFor="
                  let office of providerOfficeGroups;
                  let officeIndex = index;
                  trackBy: trackByProviderOfficeGroup
                ">


                <!-- OFFICE WITH PROVIDERS -->
                <ng-container
                  *ngIf="
                    office.providers &&
                    office.providers.length > 0
                  ">

                  <tr
                    *ngFor="
                      let provider of office.providers;
                      let providerIndex = index;
                      trackBy: trackByProvider
                    "
                    [class.provider-group-start]="
                      providerIndex === 0
                    ">


                    <!-- OFFICE -->
                    <td
                      *ngIf="providerIndex === 0"
                      [attr.rowspan]="office.providers.length"
                      class="provider-office-cell">

                      <div class="provider-office-info">

                        <div class="provider-office-icon">
                          <i class="fas fa-building"></i>
                        </div>

                        <div class="provider-office-details">

                          <span class="provider-office-name">
                            {{ office.officeName || '-' }}
                          </span>

                          <span class="provider-office-total">
                            Total Requests:
                            <strong>
                              {{ office.totalCount || 0 }}
                            </strong>
                          </span>

                        </div>

                      </div>

                    </td>


                    <!-- PROVIDER -->
                    <td class="provider-name-cell">

                      <div class="provider-name-wrap">

                        <span class="provider-name">
                          {{ getProviderName(provider) }}
                        </span>

                        <span
                          class="provider-email"
                          *ngIf="provider.userName">

                          {{ provider.userName }}

                        </span>

                      </div>

                    </td>


                    <!-- TOTAL -->
                    <td class="text-center">

                      <span
                        class="badge badge-pill badge-soft badge-assigned">

                        {{ provider.totalCount || 0 }}

                      </span>

                    </td>


                    <!-- VERIFIED -->
                    <td class="text-center">

                      <span
                        class="badge badge-pill badge-soft badge-verified"
                        matTooltip="{{
                          getFormTypesTooltip(
                            provider?.verificationStatus
                              ?.VERIFIED?.formTypes
                          )
                        }}"
                        matTooltipPosition="below"
                        matTooltipClass="form-types-tooltip">

                        {{
                          getProviderVerificationCount(
                            provider,
                            'VERIFIED'
                          )
                        }}

                      </span>

                    </td>


                    <!-- PENDING -->
                    <td class="text-center">

                      <span
                        class="badge badge-pill badge-soft badge-pending"
                        matTooltip="{{
                          getFormTypesTooltip(
                            provider?.verificationStatus
                              ?.PENDING?.formTypes
                          )
                        }}"
                        matTooltipPosition="below"
                        matTooltipClass="form-types-tooltip">

                        {{
                          getProviderVerificationCount(
                            provider,
                            'PENDING'
                          )
                        }}

                      </span>

                    </td>


                    <!-- NOT VERIFIED -->
                    <td class="text-center">

                      <span
                        class="badge badge-pill badge-soft badge-notverified"
                        matTooltip="{{
                          getFormTypesTooltip(
                            provider?.verificationStatus
                              ?.NOT_VERIFIED?.formTypes
                          )
                        }}"
                        matTooltipPosition="below"
                        matTooltipClass="form-types-tooltip">

                        {{
                          getProviderVerificationCount(
                            provider,
                            'NOT_VERIFIED'
                          )
                        }}

                      </span>

                    </td>


                    <!-- STATUS -->
                    <td class="text-center">

                      <span
                        class="badge badge-pill"
                        [ngClass]="
                          getProviderPresenceBadgeClass(
                            provider
                          )
                        ">

                        <span
                          class="status-dot"
                          [ngClass]="
                            getProviderPresenceDotClass(
                              provider
                            )
                          ">
                        </span>

                        {{
                          getProviderPresenceLabel(
                            provider
                          )
                        }}

                      </span>

                    </td>

                  </tr>

                </ng-container>


                <!-- OFFICE WITHOUT PROVIDERS -->
                <tr
                  *ngIf="
                    !office.providers ||
                    office.providers.length === 0
                  "
                  class="provider-group-start">

                  <td class="provider-office-cell">

                    <div class="provider-office-info">

                      <div class="provider-office-icon">
                        <i class="fas fa-building"></i>
                      </div>

                      <div class="provider-office-details">

                        <span class="provider-office-name">
                          {{ office.officeName || '-' }}
                        </span>

                        <span class="provider-office-total">
                          Total Requests:
                          <strong>
                            {{ office.totalCount || 0 }}
                          </strong>
                        </span>

                      </div>

                    </div>

                  </td>

                  <td
                    colspan="6"
                    class="text-center fw-semibold empty-row">

                    No providers assigned

                  </td>

                </tr>

              </ng-container>


              <!-- NO OFFICES -->
              <tr
                *ngIf="
                  !providerOfficeGroups ||
                  providerOfficeGroups.length === 0
                ">

                <td
                  colspan="7"
                  class="text-center fw-semibold empty-row">

                  No provider records found!

                </td>

              </tr>

            </tbody>

          </table>

        </div>

      </div>

    </div>

    <div class="dashboard-panel provider-future-card">

      <div class="panel-header provider-metrics-header">

        <div>
          <h4 class="panel-title">
            Status Analysis
          </h4>

          <span class="provider-trend-subtitle">
            Patient verification status summary
          </span>
        </div>

      </div>


      <div class="panel-body provider-trend-body">

        <!-- Loading -->
        <div
          *ngIf="providerTrendLoading"
          class="provider-trend-state">

          <i class="fas fa-spinner fa-spin"></i>

          <span>
            Loading trend analysis...
          </span>

        </div>


        <!-- Error -->
        <div
          *ngIf="
            !providerTrendLoading &&
            providerTrendError
          "
          class="provider-trend-state provider-trend-error">

          <i class="fas fa-exclamation-circle"></i>

          <span>
            Unable to load trend analysis.
          </span>

        </div>


        <!-- No data -->
        <div
          *ngIf="
            !providerTrendLoading &&
            !providerTrendError &&
            providerTrendData.length === 0
          "
          class="provider-trend-state">

          No trend data available.

        </div>


        <!-- Chart -->
        <div
          *ngIf="
            !providerTrendLoading &&
            !providerTrendError &&
            providerTrendData.length > 0
          "
          class="provider-trend-chart-wrap">

          <canvas id="providerTrendChart"></canvas>

        </div>

      </div>

    </div>
  
    </div>
  </div>
</div>